import {Component, Input} from '@angular/core';
import {EventResponse} from '../../models/response.module';
import {formatDateDMY, formatTimeDMYHHMM} from '../../../@core/utils/utils.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-event-card',
  standalone: false,
  templateUrl: './event-card.html',
  styleUrl: './event-card.css'
})
export class EventCard {
  @Input() event: EventResponse

  constructor(private router: Router) {
  }


  navigateToManageEvent(eventId: number) {
    this.router.navigate([`company-profile/manage-event/${eventId}`]);
  }

  protected readonly formatDateDMY = formatDateDMY;
  protected readonly formatTimeDMYHHMM = formatTimeDMYHHMM;
}
